export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.8.0',
};
//# sourceMappingURL=buildEnv.js.map